import { all, fork, put, takeEvery, call } from 'redux-saga/effects';
import { GET_INVENTORY_REPORT } from './constants';
import { getInventoryReportSuccessActions, getInventoryReportFailedActions } from './actions';
import { getInventoryReport } from './api';

function* getInventoryReportSaga({ payload }) {
    try {
        const response = yield call(getInventoryReport, payload);
        yield put(getInventoryReportSuccessActions(response.data));
    } catch (error) {
        const message = typeof error === 'string' ? error : error?.message || String(error);
        yield put(getInventoryReportFailedActions(message));
    }
}

export function* watchGetInventoryReport() {
    yield takeEvery(GET_INVENTORY_REPORT, getInventoryReportSaga);
}

function* reportsSaga() {
    yield all([fork(watchGetInventoryReport)]);
}

export default reportsSaga;
